function scrollToVariantSelectors() {
  const variantSelectors = document.querySelector('[id*="ProductInfo-template"]');
  if (variantSelectors) {
    variantSelectors.scrollIntoView({ behavior: "smooth" });
  }
}

const stickyAtc = document.querySelector(".sticky-atc");
const stickyAtcButton = document.querySelector('.sticky-atc-button[data-add-to-cart]');
const stickyAtcText = stickyAtcButton?.querySelector('span');
const productButtons = document.querySelector(".product__info-wrapper");

// Show/hide sticky ATC based on product info visibility
if (stickyAtc && productButtons) {
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        stickyAtc.style.display = "flex";
        stickyAtc.style.opacity = 1;
        stickyAtc.style.visibility = "visible";
      } else {
        stickyAtc.style.opacity = 0;
        stickyAtc.style.visibility = "hidden";
        setTimeout(() => {
          stickyAtc.style.display = "none";
        }, 300);
      }
    });
  });

  observer.observe(productButtons);
}

// Add to cart handler
stickyAtcButton?.addEventListener('click', function (event) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const id_input = document.querySelector('.sticky-atc-id');
  var error = false;
  if (!id_input) return;

  if (stickyAtcButton.getAttribute('aria-disabled') === 'true') return;

  stickyAtcButton.setAttribute('aria-disabled', true);
  stickyAtcButton.classList.add('loading');
  stickyAtcButton.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData();
  formData.append(id_input.name, Number(id_input.value));
  formData.append('quantity', 1);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });

        const soldOutMessage = stickyAtc.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        stickyAtcButton.setAttribute('aria-disabled', true);
        stickyAtcText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        error = true;
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      error = false;
      cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      stickyAtcButton.classList.remove('loading');
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (!error) stickyAtcButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
});

// Variant change handler
subscribe('variant-change', (eventData) => {
  const variant = eventData.data.variant;
  if (!variant) return;

  const optionsText = document.querySelector('.atc-variant-options');
  const variantImage = document.querySelector('.atc-image');
  const idInput = document.querySelector('.sticky-atc-id');

  if (idInput) {
    idInput.value = variant.id;
  }

  if (optionsText) {
    const options = [variant.option1, variant.option2, variant.option3]
      .filter((opt) => opt)
      .join(', ');
    optionsText.textContent = options;
  }

  if (variantImage && variant.featured_image) {
    variantImage.src = variant.featured_image.src;
  }

  // --- SOLD OUT LOGIC ON VARIANT CHANGE (matches buy-buttons.liquid) ---
  const soldoutDataEl = document.querySelector('#variant-soldout-data');
  if (!soldoutDataEl || !stickyAtcButton || !stickyAtcText) return;

  let soldoutData;
  try {
    soldoutData = JSON.parse(soldoutDataEl.textContent);
  } catch (e) {
    console.error('Failed to parse soldout data:', e);
    return;
  }

  const rules = soldoutData[variant.id];

  if (!rules) {
    // Fallback: assume buyable if we have no rules for this variant
    stickyAtcButton.disabled = false;
    stickyAtcButton.setAttribute('aria-disabled', 'false');
    stickyAtcButton.style.opacity = '1';
    stickyAtcText.textContent =
      window.theme?.strings?.addToCart || 'Add to cart';
    return;
  }

  let isSoldOut = false;

  // Check if manual inventory control is enabled
  const manualControlEnabled = document.body.dataset.manualInventoryControl === 'true';

  if (manualControlEnabled) {
    // Manual control logic: check manual metafield
    const manualRaw = rules.manualSoldOut;
    const manualSoldOut =
      manualRaw === true ||
      manualRaw === 'true' ||
      manualRaw === 1 ||
      manualRaw === '1';

    if (manualSoldOut) {
      isSoldOut = true;
    }

    // STILL respect Shopify inventory if continue-selling = false
    if (rules.inventoryManaged === 'shopify') {
      const inventoryQty = Number(rules.inventoryQty);
      const continuePolicy = rules.continueSelling;

      if (continuePolicy !== 'continue' && inventoryQty <= 0) {
        isSoldOut = true;
      }
    }
  } else {
    // Standard inventory check (when manual control is OFF)
    const inventoryQty = Number(rules.inventoryQty);
    const denySelling =
      rules.inventoryManaged === 'shopify' &&
      rules.continueSelling !== 'continue' &&
      inventoryQty <= 0;

    isSoldOut = denySelling;
  }

  // Update button state
  stickyAtcButton.disabled = isSoldOut;
  stickyAtcButton.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');
  stickyAtcButton.style.opacity = isSoldOut ? '0.75' : '1';

  stickyAtcText.textContent = isSoldOut
    ? window.theme?.strings?.soldOut || 'Sold out'
    : window.theme?.strings?.addToCart || 'Add to cart';
});